import React from 'react';

export default ({ isOrgList, isIsraeli, participants }) => (
    <div className="table-container modal-table">
        <table className="table">
            <thead>
                {isIsraeli
                    ? <tr className="table-header table-row">
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Previous Address</th>
                        <th>Email</th>
                        <th>Teudat Zehut</th>
                        <th>Bank No.</th>
                        <th>Branch No.</th>
                        <th>Account No.</th>
                        <th>Account Holder</th>
                        {isOrgList && <th>Position</th>}
                    </tr>
                    : <tr className="table-header table-row">
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Previous Address</th>
                        <th>Email</th>
                        {isOrgList && <th>Position</th>}
                    </tr>}
            </thead>
            <tbody>
                {participants.map(participant => <tr key={participant.externalListMemberId} className="table-row">
                    <td data-label="Name">
                        <p>{participant.displayName}</p>
                    </td>
                    <td data-label="Phone">
                        <p>{participant.phoneNumber.join(' | ')}</p>
                    </td>
                    <td data-label="Address">
                        <p>{participant.address}</p>
                    </td>
                    <td data-label="Previous Address">
                        <p>{participant.previousAddress}</p>
                    </td>
                    <td data-label="Email">
                        <p style={{ "wordBreak": "break-all" }}>{participant.email}</p>
                    </td>
                    {isIsraeli && <td data-label="TeudatZehut">
                        <p>{participant.teudatZahut}</p>
                    </td>}
                    {isIsraeli && <td data-label="RoutingNum">
                        <p>{participant.bankRoutingNumber}</p>
                    </td>}
                    {isIsraeli && <td data-label="BranchNum">
                        <p>{participant.bankBranchNumber}</p>
                    </td>}
                    {isIsraeli && <td data-label="AccountNum">
                        <p>{participant.bankAccountNumber}</p>
                    </td>}
                    {isIsraeli && <td data-label="AccountHolder">
                        <p>{participant.bankAccountHolder}</p>
                    </td>}
                    {isOrgList && <td data-label="Position">
                        <p>{participant.orgEmployment}</p>
                    </td>}
                </tr>)}
            </tbody>
        </table>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/WizardParticipantsTable.jsx